import { defineComponent as n, computed as p, openBlock as r, createBlock as c, unref as s } from "vue";
import a from "../assets/icons/first-page.svg.mjs";
const u = /* @__PURE__ */ n({
  __name: "first-page-icon",
  props: {
    fill: { default: "currentColor" },
    size: { default: "md" }
  },
  setup(e) {
    const l = e, i = {
      sm: "12px",
      md: "16px",
      lg: "24px",
      xl: "32px",
      "2xl": "48px"
    }, o = p(() => i[l.size]);
    return (t, f) => (r(), c(s(a), {
      fill: t.fill,
      width: o.value,
      style: {
        verticalAlign: "middle",
        display: "inline-block",
        height: "auto"
      }
    }, null, 8, ["fill", "width"]));
  }
});
export {
  u as default
};
//# sourceMappingURL=first-page-icon.vue.mjs.map
